var _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPartnersinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#F1F1F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 18a3.6 3.6 0 00-1.655-3.043 3.623 3.623 0 00-4.302-4.302 3.623 3.623 0 00-6.084 0 3.624 3.624 0 00-4.303 4.302 3.624 3.624 0 000 6.086 3.621 3.621 0 004.302 4.302 3.623 3.623 0 006.084 0 3.62 3.62 0 004.302-4.302A3.6 3.6 0 0027 18zm-5.878 3.174a.316.316 0 01-.445.402l-2.493-1.4a.375.375 0 00-.369 0l-2.491 1.4a.318.318 0 01-.445-.403l1.014-2.333a.374.374 0 00-.094-.43l-1.734-1.545a.316.316 0 01.21-.552h2.058a.375.375 0 00.344-.225l1.032-2.395a.317.317 0 01.581 0l1.033 2.395a.375.375 0 00.344.225h2.057a.316.316 0 01.211.552l-1.734 1.545a.376.376 0 00-.094.43l1.015 2.334z",
    fill: "#0F0449"
  })));
}

export default SvgPartnersinline;